export interface CareRatioBenchmark {
  scaleMin: number;
  scaleMax: number;
  typicalMin: number;
  typicalMax: number;
}

export interface BenchmarkReference {
  labelKey: string;
  source: string;
  value: string;
}

export interface BenchmarkSource {
  title: string;
  url: string;
}

export const CARE_RATIO_BENCHMARK: CareRatioBenchmark = {
  scaleMin: 30,
  scaleMax: 160,
  typicalMin: 50,
  typicalMax: 100,
};

export const BENCHMARK_REFERENCES: BenchmarkReference[] = [
  {
    labelKey: 'project.steps.companyInfo.benchmarkInternationalAverage',
    source: 'Haufe Personalcontrolling-Kennzahlen',
    value: '≈ 1:89',
  },
  {
    labelKey: 'project.steps.companyInfo.benchmarkCapGeminiLean',
    source: 'The HR Factory, HR-Kennzahlen',
    value: '≥ 1:100',
  },
  {
    labelKey: 'project.steps.companyInfo.benchmarkCapGeminiMedium',
    source: 'The HR Factory, HR-Kennzahlen',
    value: '1:60 – 1:99',
  },
  {
    labelKey: 'project.steps.companyInfo.benchmarkCapGeminiFat',
    source: 'The HR Factory, HR-Kennzahlen',
    value: '≤ 1:59',
  },
  {
    labelKey: 'project.steps.companyInfo.benchmarkUsMedian',
    source: 'The HR Factory, HR-Kennzahlen',
    value: '≈ 1:91',
  },
  {
    labelKey: 'project.steps.companyInfo.benchmarkGermanMidsize',
    source: 'Personalmagazin 07/2021',
    value: '1:50 – 1:90',
  },
  {
    labelKey: 'project.steps.companyInfo.benchmarkInternationalTarget',
    source: 'Papmehl HR Benchmark 2011',
    value: '1:100 bzw. 1:140',
  },
];

export const BENCHMARK_SOURCES: BenchmarkSource[] = [
  {
    title: 'Haufe — Personalcontrolling: Kennzahlen, Betreuungsquote',
    url: 'https://www.haufe.de/id/beitrag/personalcontrolling-kennzahlen-124-betreuungsquote-HI4823883.html',
  },
  {
    title: 'Harbinger Consulting — Größe der Personalabteilung vs. Mitarbeiteranzahl',
    url: 'https://www.harbinger-consulting.com/blog/groesse-der-personalabteilung/',
  },
  {
    title: 'Kienbaum — HR-to-employee-Ratio (Betreuungsquote)',
    url: 'https://www.kienbaum.com/glossar/hr-to-employee-ratio-betreuungsquote/',
  },
  {
    title: 'The HR Factory — HR-Kennzahlen (Cap Gemini HR Barometer, Bloomberg BNA)',
    url: 'https://www.thehrfactory.ch/wp-content/uploads/2017/03/HR-Kennzahlen-Homepage-Aktuell.pdf',
  },
  {
    title: 'Papmehl — HR Benchmark 2011',
    url: 'https://www.papmehl.com/images/stories/studien/HR_Benchmark_2011.pdf',
  },
  {
    title: 'Personalmagazin 07/2021 — HR-Benchmarking im Mittelstand',
    url: 'https://s54cab8e7c0ef08df.jimcontent.com/download/version/1625155696/module/11763066493/name/Thomas_Batsching_PM0721_046-049_HR-Benchmarking.pdf',
  },
];
